import { products } from '../data/products.js';

function asTrimmedString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function resolveCatalogProductBySku(productSku) {
  const sku = asTrimmedString(productSku);
  if (!sku) return null;
  return products.find((product) => product?.sku === sku) || null;
}

export function resolveOpsProductRefs(item = {}) {
  const productSku = asTrimmedString(item.productSku || item.product || item.sku);
  const explicitName = asTrimmedString(item.productName || item.name);
  const catalogProduct = resolveCatalogProductBySku(productSku);
  const productName = asTrimmedString(catalogProduct?.nameHe || catalogProduct?.name || explicitName);

  return {
    productName: productName || explicitName,
    productSku,
    productLabel: productName || explicitName || productSku || 'Product',
  };
}
